import React, { memo } from "react";
import { IconButton, Typography, TypographyProps } from "@material-ui/core";
import useAppInteractiveTypography from "./index.hooks";
import { AppTextField } from "components/index";
import { AppTextFieldProps } from "components/AppTextField";
import EditIcon from "@material-ui/icons/Edit";

type AppInteractiveTypographyProps = {
  edit: boolean;
  interaction: () => void;
  typoProps?: TypographyProps;
  inputProps?: AppTextFieldProps;
  badgePos?: { l?: number; t?: number; b?: number; r?: number };
  hiddenBadge?: boolean;
  typoText?: string;
  typoLabel?: string;
};

const AppInteractiveTypography = ({
  inputProps,
  interaction,
  hiddenBadge,
  badgePos,
  edit,
  typoProps,
  typoText,
  typoLabel,
}: AppInteractiveTypographyProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    visibleEdit,
    handleOver,
    handleOut,
  } = useAppInteractiveTypography();

  return (
    <div className={styles.AITContainer}>
      <AppTextField {...inputProps} hidden={!edit} />
      <div className={styles.typoContainer}>
        {typoLabel && !edit && (
          <Typography
            variant={"body1"}
            color={"primary"}
            className={styles.typoLabel}
            onClick={interaction}
            onMouseOver={handleOver}
            onMouseOut={handleOut}
          >
            {typoLabel}
          </Typography>
        )}
        <Typography
          {...typoProps}
          noWrap
          className={edit ? styles.hidden : styles.clickableTypo}
          onClick={interaction}
          onMouseOver={handleOver}
          onMouseOut={handleOut}
        >
          {typoText ?? inputProps.value}
          <IconButton
            disabled
            className={visibleEdit && !hiddenBadge ? "" : styles.hidden}
            style={{
              position: "absolute",
              top: badgePos?.t ?? -10,
              bottom: badgePos?.b,
              left: badgePos?.l,
              right: badgePos?.r,
            }}
          >
            <EditIcon />
          </IconButton>
        </Typography>
      </div>
    </div>
  );
};

export default memo(AppInteractiveTypography);
